<div class="mini-grid aligned">
    <i [class]="color" class="fa fa-circle aligned"></i>
    <h3>{{ status }}</h3>
</div>